export const SYSTEM_ENV =
    import.meta.env.MODE === 'production'
        ? ['localhost', 'test', '127.0.0.1'].some((search) => window.location.host.includes(search))
            ? 'test'
            : window.location.host.includes('prep')
                ? 'prep'
                : 'prod'
        : 'test';
